export const gstRates = [
  {
    rate: "0%",
    label: "Nil Rate",
    color: "emerald",
    description: "Essential goods & services — fully exempt from GST",
    items: [
      "UHT Milk, Paneer & Chena (pre-packaged)",
      "Roti, Chapati, Khakhra, Pizza Bread",
      "Fresh fruits & vegetables",
      "Individual Life & Health Insurance policies",
      "33 Lifesaving drugs & medicines (incl. cancer drugs)",
      "Educational services & books",
      "Pencils, Erasers, Sharpeners, Notebooks, Maps",
      "Healthcare services (hospitals & clinics)",
      "Unbranded cereals, flour & pulses",
    ],
  },
  {
    rate: "5%",
    label: "Merit Rate",
    color: "blue",
    description: "Daily essentials & merit goods — concessional rate",
    items: [
      "Hair Oil, Soap, Shampoo, Toothpaste, Toothbrush",
      "Butter, Ghee, Cheese & Dairy spreads",
      "Namkeen, Bhujia, Sauces, Pasta, Noodles",
      "Chocolates, Coffee, Cornflakes, Biscuits",
      "Footwear & Apparel (up to ₹2,500 per piece)",
      "Medical devices & diagnostic kits",
      "Agricultural machinery & drip irrigation equipment",
      "Bicycles & parts",
      "Restaurants (non-premises), Economy air travel",
      "Other medicines & pharma (not in nil list)",
    ],
  },
  {
    rate: "18%",
    label: "Standard Rate",
    color: "indigo",
    description: "Most goods & services — the default standard rate",
    items: [
      "Air Conditioners, TVs (all sizes), Dishwashers",
      "Small cars (petrol ≤1200cc / diesel ≤1500cc)",
      "Motorcycles up to 350cc",
      "Cement & construction materials",
      "Auto parts & components",
      "Electronics, Laptops & Mobile phones",
      "Telecom, IT & Financial services",
      "Insurance (other than individual life/health)",
      "Hotels (₹7,500+ tariff), Premium restaurants",
      "Capital goods & industrial machinery",
    ],
  },
  {
    rate: "40%",
    label: "Demerit Rate",
    color: "red",
    description: "Luxury & sin goods — highest slab (replaces 28% + cess)",
    items: [
      "Pan Masala, Gutkha & Chewing tobacco",
      "Cigarettes & other tobacco products",
      "Aerated, Caffeinated & Carbonated drinks",
      "Luxury cars (petrol >1200cc / diesel >1500cc)",
      "Motorcycles above 350cc",
      "Yachts & Private aircraft",
      "Online money gaming",
      "Casinos, Betting & Gambling",
      "Racing club services & lottery",
    ],
  },
];

export const gstSpecialRates = [
  { rate: "3%", items: "Gold, Silver & Platinum jewellery" },
  { rate: "1.5%", items: "Cut & polished diamonds" },
  { rate: "0.25%", items: "Rough diamonds & precious stones" },
];

export const NEW_REGIME_SLABS = [
  { upto: 400000, rate: 0 },
  { upto: 800000, rate: 0.05 },
  { upto: 1200000, rate: 0.1 },
  { upto: 1600000, rate: 0.15 },
  { upto: 2000000, rate: 0.2 },
  { upto: 2400000, rate: 0.25 },
  { upto: Infinity, rate: 0.3 },
];

export const oldRegimeSlabs = (age) => {
  const exemption = age === "80+" ? 500000 : age === "60-80" ? 300000 : 250000;
  return [
    { upto: exemption, rate: 0 },
    { upto: 500000, rate: 0.05 },
    { upto: 1000000, rate: 0.2 },
    { upto: Infinity, rate: 0.3 },
  ];
};

const slabTax = (income, slabs) => {
  let tax = 0;
  let prev = 0;
  for (const s of slabs) {
    if (income > prev) {
      tax += (Math.min(income, s.upto) - prev) * s.rate;
      prev = s.upto;
    } else break;
  }
  return tax;
};

const surchargeRate = (income, isNew) => {
  if (income > 50000000) return isNew ? 0.25 : 0.37;
  if (income > 20000000) return 0.25;
  if (income > 10000000) return 0.15;
  if (income > 5000000) return 0.1;
  return 0;
};

export const computeNewRegime = (grossIncome, isSalaried) => {
  const stdDeduction = isSalaried ? Math.min(75000, grossIncome) : 0;
  const taxable = Math.max(0, grossIncome - stdDeduction);
  let tax = slabTax(taxable, NEW_REGIME_SLABS);
  let rebate = 0;
  if (taxable <= 1200000) {
    rebate = tax;
    tax = 0;
  } else if (taxable <= 1275000) {
    const marginal = taxable - 1200000;
    if (tax > marginal) {
      rebate = tax - marginal;
      tax = marginal;
    }
  }
  const surcharge = tax * surchargeRate(taxable, true);
  const cess = (tax + surcharge) * 0.04;
  return { taxable, stdDeduction, baseTax: tax + rebate, rebate, tax, surcharge, cess, total: Math.round(tax + surcharge + cess) };
};

export const computeOldRegime = (grossIncome, deductions, age, isSalaried) => {
  const stdDeduction = isSalaried ? Math.min(50000, grossIncome) : 0;
  const taxable = Math.max(0, grossIncome - stdDeduction - deductions);
  let tax = slabTax(taxable, oldRegimeSlabs(age));
  let rebate = 0;
  if (taxable <= 500000) {
    rebate = Math.min(tax, 12500);
    tax -= rebate;
  }
  const surcharge = tax * surchargeRate(taxable, false);
  const cess = (tax + surcharge) * 0.04;
  return { taxable, stdDeduction, baseTax: tax + rebate, rebate, tax, surcharge, cess, total: Math.round(tax + surcharge + cess) };
};

export const formatINR = (n) =>
  "₹" + Math.round(n).toLocaleString("en-IN");

export const advanceTaxSchedule = (netLiability) => [
  { due: "15th June", cumulative: 0.15, label: "1st Installment", amount: Math.round(netLiability * 0.15) },
  { due: "15th September", cumulative: 0.45, label: "2nd Installment", amount: Math.round(netLiability * 0.3) },
  { due: "15th December", cumulative: 0.75, label: "3rd Installment", amount: Math.round(netLiability * 0.3) },
  { due: "15th March", cumulative: 1, label: "4th Installment", amount: Math.round(netLiability * 0.25) },
];
